import axios from './index'


const origin = '/co/member/';


const register = (param) => {
    return new Promise((resolve) => {
        axios.post(origin + '/register', param).then(res => resolve(res));
    });
}
const getCode = (param) => {
    return new Promise((resolve) => {
        axios.post(origin + '/GetCode', param).then(res => resolve(res));
    });
}
const isRepeatName = (param) => {
    return new Promise((resolve) => {
        axios.post(origin + '/IsRepeatName', param).then(res => resolve(res));
    });
}
const isRepeatRegistCode = (param) => {
    return new Promise((resolve) => {
        axios.post(origin + '/IsRepeatRegistCode', param).then(res => resolve(res));
    });
}

const isRepeatUserName = (param) => {
    return new Promise((resolve) => {
        axios.post(origin + '/IsRepeatUserName', param).then(res => resolve(res));
    });
}

export default {
    register,
    getCode,
    isRepeatName,
    isRepeatRegistCode,
    isRepeatUserName,
}